import { useEffect, useState } from "react";
import { StatusBar } from "../common";
import { getQueryVariables } from "../../utils";
import { useQuery, gql } from "@apollo/client";
import {GraphQLPagination} from "../common";
import { useSearchParams } from "react-router-dom";
import GenericSelectableTable from "../selectableTable";
import { NXEditPen } from "../../icons";
import InvoiceSettingForm from "./invoiceSettingForm";



const GET_INVOICE_SETTINGS = gql`
  query MyQuery(
    $first: Int
    $last: Int
  ) {
    invoiceSettings(
      first: $first
      last: $last
    ) {
      edges {
        node {
          city
          contactEmail
          storeName
          dbId
          isDefault
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

const InvoiceSettings = () => {
    const [openForm, setOpenForm] = useState<boolean>(false);
  const [editId, setEditId] = useState<string>("");
    const [searchParams, setSearchParams] = useSearchParams();
  


  const { data, loading, error, refetch } = useQuery(GET_INVOICE_SETTINGS, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });





  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);

  const columns = [
    { header: "ID", key: "node.dbId" },
    { header: "Store Name", key: "node.storeName" },
    { header: "City", key: "node.city" },
    { header: "Contact Email", key: "node.contactEmail" },
    { header: "Is Default", key: "node.isDefault", render: (item: any) => (
      <div className="flex items-center">
          {item.node.isDefault ? (
          <span className="text-green-500">&#10003;</span>
          ) : (
          <span className="text-red-500">&#10007;</span>
          )}
      </div>
    )},

    { header: "Actions", key: "actions", render: (item: any) => (
      <div className="flex gap-2">
          {/* <button className="p-1" onClick={() => handleDelete(item.id, 'Product', api.deleteProduct, fetchProducts)}>
              <NXDelete />
          </button> */}
            <button onClick={() => { setEditId(item.node.dbId); setOpenForm(true); }} className="p-1">
              <NXEditPen />
            </button>
      </div>
  )}
  ];

  const handleClose = () => {
    setOpenForm(false);
    setEditId("");
  }

  return (
    <div className="h-full bg-white">
      <div className="bg-white">
      <div className="bg-white">
        <div className="bg-white">
        <h3 className="font-bold text-[18px]">Invoice Settings</h3>
        <p className="text-base-300 text-sm py-2">
          Invoice settings for your store. 
        </p>

        <StatusBar
          onButtonClick={() => setOpenForm(!openForm)}
          statusList={[]}
          buttonLabel="Add New Invoice Setting"
          fieldName="status"
        />
        
        <GenericSelectableTable columns={columns} data={data?.invoiceSettings?.edges || []} />

        <GraphQLPagination 
          edges={data?.invoiceSettings?.edges || []}
          pageInfo={data?.invoiceSettings?.pageInfo || {}}
          />

          </div>
        </div>
      </div>



    {openForm && <InvoiceSettingForm id={editId} isOpen={openForm}  onClose={handleClose} refresh={refetch} />}

    </div>
  );
};

export default InvoiceSettings;
